import { Entity, Field } from "typegraph";

import Message from "panels/organizations/admin/announcements/entities/Message";

@Entity({one: "organization", many: "organizations"})
export default class OrganizationMessages {

	@Field()
	public id: string;

	@Field()
	public name: string;

	@Field({entity: Message})
	public messageList: Message[];

}



// WEBPACK FOOTER //
// ./src/panels/organizations/admin/announcements/entities/OrganizationMessages.ts